import { observable, action } from "mobx";
import { findIndex } from "lodash";
import { ConsultantEditorStore } from "../../ConsultantEditorStore";
import {
  ExpertiseProfession,
  ExpertiseProfessionStore
} from "../ExpertiseProfessionStore";
import { ExpHelper } from "../Common/ExpHelper";

export interface RadiographersProfession extends ExpertiseProfession {
  specializations: Specialization[];
  machines: string[];
}

export interface Specialization {
  name: string;
  yearFrom: string;
  interested: boolean;
  comment: string;
  qualified: boolean;
}

export class RadiographersStore extends ExpertiseProfessionStore<RadiographersProfession> {
  @observable selectedSpecialization: string[];

  constructor(
    profession: string,
    storeIndex: number,
    public readonly editorStore: ConsultantEditorStore
  ) {
    super(profession, storeIndex, editorStore);
    this.selectedSpecialization = null;
  }

  get specializations(): Specialization[] {
    return this.currentExpertiseProfession?.specializations ?? [];
  }

  get prof() {
    return this.profession;
  }

  private get selectAoEList() {
    return this.editorStore.getAOEsOnProfession(this.profession);
  }

  get selectSpecializationList() {
    return ExpHelper.uniqFlatten<string>(
      this.selectAoEList.map((x) =>
        this.editorStore.getSpecialization(x, this.profession)
      )
    ).filter((x) => !this.specializations.any((y) => y.name === x));
  }

  get systems(): string[] {
    return this.editorStore.getSystemsOnProfession(this.profession);
  }

  get machines() {
    return this.editorStore.getMachinesOnProfession(this.profession);
  }

  @action setSelectedSpecialization = (val: string[]) => {
    this.selectedSpecialization = val;
  };

  addSpec = () => {
    this.selectedSpecialization.map((x) => {
      const i = findIndex(this.specializations, (a) => a.name === x);
      if (i === -1) {
        super.addSpec<Specialization>({
          name: x,
          yearFrom: "",
          interested: true,
          qualified: true,
          comment: ""
        });
      }
    });
    this.setSelectedSpecialization(null);
  };

  @action removeSpec = (path: string, i: number) => {
    this.editorStore.form.removeByIndex(path, i);
  };

  initForm() {
    if (!this.currentExpertiseProfession) {
      this.editorStore.form.setValue(`professions.${this.storeIndex}`, {
        professionName: this.profession,
        specializations: [],
        machines: []
      });
    }
  }
}
